import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";
import TypeformContent from "../../../typeform/TypeformContent";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";

class TeamReportsSection2Step5 extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    let val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  };

  get ROIC() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "ROIC") * 100
      });
    });

    return data;
  }

  get left_content() {
    return (
      <span>
        Investors use this metric to measure how well a business used its
        capital to generate profits. The higher the ROIC, the better.
        <br />
        <br />
        <div className="formula">
          ROIC =
          <div className="formula">
            AVERAGE NET PROFITS
            <hr />
            INVESTED CAPITAL
          </div>
        </div>
        <br />
        <br />
        How could you maximize your ROIC?
        <br />
        <br />
        To learn more about ROIC, please click here &rarr;
        <TypeformLink
          title="Return on Invested Capital"
          url={TypeformUrls.ROIC}
          className="link-with-margin"
        />
      </span>
    );
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <VerticalBarChart suffix="%" data={this.ROIC} />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Return on Invested Capital
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="xs"
            {...TypeformContent.ROIC_KPI}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Return on Invested Capital"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step5;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-5.js